import { Image } from "angular-modal-gallery";

export class ReporteTarea {

public // public title:  :  : string;

public   idCompania: string;
public   idVisita: string;
public   idTarea: string;
public   tipoTarea: string;
public   numeroDocumento: string;
public   numeroOrden: string;
public   clasificacion: string;
public   codigo: string;
public   descripcion: string;
public   unidadMedida: string;
public  cantidad: number;
public  cantidadConfirmada: number;

public  peso: number;
public  volumen: number;
public   estadoTarea: string;
public   observaciones: string;

public  fechaInicio: Date;
public fechaFinalizacion: Date;

public   latitud: string;
public   longitud: string;
public   imagen: string;

//PARA EL REPORTE DE DEVOLUCION LIBRE
public image:Image;

}